export interface Article {
  id: number;
  title: string;
  summary: string;
  category: string;
  categorySlug: string;
  cover: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
  featured?: boolean;
  content: { heading?: string; paragraphs: string[] }[];
}

export const articles: Article[] = [
  {
    id: 1,
    title: "2026 年七月新番前瞻：这个夏天的必追片单",
    summary: "七月新番大爆发！热血、恋爱、科幻一网打尽，为你盘点这个夏天绝对不能错过的神作。",
    category: "新番推荐",
    categorySlug: "re-xue",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20stylized%20anime%20poster%20artwork%20featuring%20a%20group%20of%20energetic%20young%20heroes%20standing%20in%20a%20heroic%20pose%20against%20a%20dramatic%20sunset%20sky%2C%20warm%20coral%20orange%20and%20teal%20color%20palette%2C%20dynamic%20composition%2C%20cinematic%20lighting%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20clean%20balanced%20background&width=1200&height=750&seq=article-01&orientation=landscape",
    author: "追番君",
    date: "2026-08-10",
    views: 12840,
    tags: ["新番推荐", "热血", "夏季番"],
    featured: true,
    content: [
      { heading: "热血当道，燃点拉满", paragraphs: ["七月新番中最让人热血沸腾的，莫过于那些以少年成长为核心的战斗番。这一季的制作水准明显提升，动作作画与分镜都达到了近年来的高水准，几乎每一帧都能看出制作组的用心。", "从王道路线的热血冒险，到风格独特的地下竞技，各种热血的打开方式应有尽有。如果你是热血番的忠实爱好者，这个夏天一定不会让你失望。"] },
      { heading: "恋爱番的甜蜜暴击", paragraphs: ["恋爱题材依然是七月新番的中坚力量。无论是校园的青涩暗恋，还是都市的成熟心动，都在用细腻的笔触描绘出爱情最动人的模样。", "本季的恋爱番在人物塑造上格外出色，角色的情绪变化真实而立体，配合上恰到好处的配乐，很容易让观众产生强烈的代入感。"] },
      { heading: "科幻与奇幻的想象力盛宴", paragraphs: ["如果你喜欢在动画中探索未知的世界，那么本季的科幻与奇幻番将是你的不二之选。从宏大的太空歌剧到精致的魔法学院，每一个设定都充满了创作者天马行空的想象力。", "这些作品不仅在画面上下足了功夫，更在故事内核中探讨了人性、命运与选择等深刻的命题，值得反复品味。"] },
    ],
  },
  {
    id: 2,
    title: "热血动漫 TOP10 盘点：那些让你燃到流泪的经典",
    summary: "从童年神作到新时代爆款，盘点十大热血动漫，每一部都是青春的记忆与泪点。",
    category: "热血",
    categorySlug: "re-xue",
    cover: "https://readdy.ai/api/search-image?query=Epic%20stylized%20anime%20illustration%20of%20a%20lone%20warrior%20holding%20a%20glowing%20blade%20facing%20a%20stormy%20golden%20sky%2C%20intense%20dramatic%20lighting%2C%20warm%20orange%20and%20deep%20teal%20contrast%2C%20cinematic%20composition%2C%20artistic%20digital%20painting%2C%20high%20detail%2C%20balanced%20clean%20background&width=1200&height=750&seq=article-02&orientation=landscape",
    author: "燃魂酱",
    date: "2026-08-06",
    views: 25631,
    tags: ["热血", "经典盘点", "TOP榜"],
    featured: true,
    content: [
      { heading: "王道热血的起点", paragraphs: ["热血动漫之所以经久不衰，在于它始终传递着一种不屈不挠的精神。无论是面对强大的敌人，还是跨越重重难关，主角们用行动诠释着什么是真正的勇气与坚持。", "这份「燃」，不仅仅来自激烈的战斗场面，更来自角色每一次的突破与成长，让屏幕前的我们也不由自主地握紧拳头。"] },
      { heading: "那些泪目的瞬间", paragraphs: ["真正优秀的热血作品，绝不是只有打打杀杀。在酣畅淋漓的战斗背后，是对友情、羁绊与信念的深情书写。", "当主角在绝境中说出那句守护伙伴的誓言，当背景音乐恰到好处地响起，无数观众在这一刻泪流满面。这就是热血动漫独有的魅力。"] },
      { heading: "新时代的传承", paragraphs: ["随着制作技术的进步，新时代的热血动漫在画面表现上更为华丽，但那份热血的内核始终未变。", "新一代创作者在继承经典的同时，也在不断探索新的叙事方式，让热血动漫这个经典题材焕发出全新的生命力。"] },
    ],
  },
  {
    id: 3,
    title: "恋爱番天花板！五部甜度爆表的治愈系恋爱神作",
    summary: "甜到发齁的恋爱番推荐，每一帧都是心动的信号，让你重新相信爱情。",
    category: "恋爱",
    categorySlug: "lian-ai",
    cover: "https://readdy.ai/api/search-image?query=Soft%20romantic%20stylized%20anime%20illustration%20of%20two%20young%20lovers%20under%20blossoming%20cherry%20trees%20at%20golden%20hour%2C%20warm%20pink%20and%20peach%20color%20palette%2C%20gentle%20sunlight%20and%20floating%20petals%2C%20sweet%20atmosphere%2C%20artistic%20digital%20painting%2C%20soft%20romantic%20lighting%2C%20high%20detail%2C%20clean%20background&width=1200&height=750&seq=article-03&orientation=landscape",
    author: "心动酱",
    date: "2026-08-02",
    views: 18209,
    tags: ["恋爱", "治愈", "推荐"],
    featured: true,
    content: [
      { heading: "心动从细节开始", paragraphs: ["恋爱番最动人的地方，往往不是轰轰烈烈的告白，而是那些不经意间的心动瞬间。一次对视、一个微笑、一句不经意的关心，都在悄悄拨动着角色的心弦。", "优秀的恋爱作品懂得用细节说话，让观众跟着主角一起脸红心跳，仿佛自己也置身于那段青涩又美好的时光之中。"] },
      { heading: "治愈系的温柔力量", paragraphs: ["这个快节奏的时代，越来越多的人选择用恋爱番来治愈自己疲惫的心灵。温柔的故事、美好的情感，就像一剂良药，抚平了我们内心的焦躁与不安。", "当你感到疲惫时，不妨打开一部恋爱番，让温柔的故事陪你度过一个安静的夜晚。"] },
      { heading: "不只是恋爱", paragraphs: ["优秀的恋爱番远不止于谈恋爱。它们往往也探讨了成长、梦想与自我认同，让角色在爱情之外，也能成为更好的自己。", "这种「恋爱+成长」的模式，让作品更有厚度，也更能引发观众的共鸣与思考。"] },
    ],
  },
  {
    id: 4,
    title: "治愈系动漫指南：在寒冷的夜里给你一个温暖的抱抱",
    summary: "忙碌的生活需要一点温柔，推荐几部治愈心灵的动漫，让温暖住进你的心里。",
    category: "治愈",
    categorySlug: "zhi-yu",
    cover: "https://readdy.ai/api/search-image?query=Calm%20soothing%20stylized%20anime%20illustration%20of%20a%20cozy%20cottage%20interior%20by%20a%20window%20with%20warm%20sunlight%2C%20cups%20of%20tea%20and%20soft%20blankets%2C%20peaceful%20green%20and%20cream%20color%20palette%2C%20gentle%20healing%20atmosphere%2C%20artistic%20digital%20painting%2C%20soft%20warm%20lighting%2C%20high%20detail%2C%20clean%20serene%20background&width=1200&height=750&seq=article-04&orientation=landscape",
    author: "暖阳桑",
    date: "2026-07-28",
    views: 9932,
    tags: ["治愈", "日常", "推荐"],
    featured: true,
    content: [
      { heading: "治愈，是一杯热茶", paragraphs: ["治愈系动漫的魔力，在于它能用最简单的日常，温暖最疲惫的心灵。一顿热腾腾的饭菜、一场安静的雨、一段慢节奏的时光，都是治愈的良方。", "这些作品没有激烈的冲突，没有宏大的叙事，有的只是细水长流的温柔，却最能触动人心最柔软的地方。"] },
      { heading: "慢下来，感受生活", paragraphs: ["在这个什么都讲究效率的时代，治愈系动漫提醒我们要慢下来，去感受生活中被忽略的美好。", "清晨的第一缕阳光，路边盛开的小花，朋友间真诚的问候，这些微小而确切的幸福，正是治愈系动漫想告诉我们的道理。"] },
      { heading: "心灵的避风港", paragraphs: ["当你感到疲惫、迷茫或孤独时，治愈系动漫就像一个温柔的避风港，无条件地接纳你所有的情绪。", "它不会告诉你答案，却会用一个个温暖的故事告诉你：没关系，一切都会好起来的。"] },
    ],
  },
  {
    id: 5,
    title: "科幻动漫新高峰：2026 年你不能错过的硬核科幻",
    summary: "赛博朋克、太空歌剧、时间悖论……盘点本年度最值得一看的硬核科幻动漫。",
    category: "科幻",
    categorySlug: "ke-huan",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20stylized%20anime%20illustration%20of%20a%20spaceship%20flying%20through%20a%20nebula%20with%20glowing%20neon%20city%20below%2C%20cool%20teal%20cyan%20and%20purple%20color%20palette%2C%20vast%20cosmic%20scale%2C%20cinematic%20depth%2C%20artistic%20digital%20painting%2C%20high%20detail%2C%20dramatic%20space%20lighting%2C%20clean%20balanced%20background&width=1200&height=750&seq=article-05&orientation=landscape",
    author: "星际漫游者",
    date: "2026-07-20",
    views: 14776,
    tags: ["科幻", "赛博朋克", "太空"],
    content: [
      { heading: "当想象力突破天际", paragraphs: ["科幻动漫最迷人的地方，在于它敢想敢画，把人类对未来的想象具象化为一个个瑰丽的世界。从霓虹闪烁的赛博都市，到浩瀚无垠的星河宇宙，每一处设定都让人叹为观止。", "本年度涌现出的一批硬核科幻作品，不仅在视觉上实现了质的飞跃，更在设定与逻辑上经得起推敲。"] },
      { heading: "硬核设定下的哲学思考", paragraphs: ["真正优秀的科幻作品，绝不只是堆砌酷炫的设定。它们往往借由未来世界，探讨人工智能、身份认同、自由意志等深刻的哲学命题。", "当科技发展到极致，人类的情感与价值将何去何从？这些作品用一个个精彩的故事，给出了发人深省的思考。"] },
      { heading: "视觉与内核的双重盛宴", paragraphs: ["对于科幻爱好者来说，本年度无疑是幸福的一年。从宏大场面的震撼，到细节考究的设定，再到引人深思的故事内核，科幻动漫正在迎来新的高峰。", "无论你是资深科幻迷，还是对科幻充满好奇的新朋友，都能在这些作品中找到属于自己的乐趣。"] },
    ],
  },
  {
    id: 6,
    title: "沙雕搞笑番合集：不开心的时候点开这一篇",
    summary: "笑到肚子疼的搞笑动漫合集，压力大时的快乐源泉，专治各种不开心。",
    category: "搞笑",
    categorySlug: "gao-xiao",
    cover: "https://readdy.ai/api/search-image?query=Playful%20stylized%20anime%20illustration%20of%20colorful%20comical%20characters%20laughing%20and%20goofing%20around%20in%20a%20bright%20cartoon%20world%2C%20vibrant%20coral%20yellow%20and%20teal%20color%20palette%2C%20fun%20dynamic%20energy%2C%20whimsical%20artistic%20digital%20illustration%2C%20high%20detail%2C%20clean%20playful%20background&width=1200&height=750&seq=article-06&orientation=landscape",
    author: "沙雕制造机",
    date: "2026-07-14",
    views: 21033,
    tags: ["搞笑", "沙雕", "日常"],
    content: [
      { heading: "快乐其实很简单", paragraphs: ["生活已经很辛苦了，为什么不在空闲时看一部搞笑番放松一下呢？夸张的表情、无厘头的剧情、突如其来的神展开，总能让你在不经意间笑出声来。", "搞笑动漫不需要复杂的思考，只需要你放下烦恼，尽情享受欢乐的时光。"] },
      { heading: "沙雕艺术永不落伍", paragraphs: ["在搞笑动漫的世界里，一切皆有可能。角色们各种离谱的操作、一本正经地说着最不靠谱的话，构成了一出出精彩的喜剧大戏。", "这种「沙雕」精神，恰恰是搞笑动漫最珍贵的财富，它教会我们用幽默化解生活的尴尬与烦恼。"] },
      { heading: "轻松解压的最佳选择", paragraphs: ["忙碌了一天之后，打开一部搞笑番，让欢快的节奏带走一身的疲惫，是许多人的解压方式。", "希望这一份搞笑合集，能在你感到疲惫时，为你带来片刻的轻松与欢笑。"] },
    ],
  },
  {
    id: 7,
    title: "异世界冒险指南：从萌新到大神的升级之路",
    summary: "异世界冒险题材全解析，从世界观设定到角色成长，带你了解这类作品的魅力。",
    category: "冒险",
    categorySlug: "mao-xian",
    cover: "https://readdy.ai/api/search-image?query=Grand%20stylized%20anime%20illustration%20of%20adventurers%20climbing%20a%20mystical%20floating%20mountain%20with%20ancient%20ruins%20and%20waterfalls%2C%20warm%20golden%20and%20emerald%20color%20palette%2C%20epic%20adventure%20atmosphere%2C%20artistic%20digital%20painting%2C%20high%20detail%2C%20cinematic%20composition%2C%20clean%20balanced%20background&width=1200&height=750&seq=article-07&orientation=landscape",
    author: "冒险家阿卡",
    date: "2026-07-06",
    views: 11204,
    tags: ["冒险", "异世界", "指南"],
    content: [
      { heading: "异世界的无限可能", paragraphs: ["异世界冒险的魅力，在于它为观众打开了一扇通往全新世界的大门。在那里，魔法与剑术并存，勇者与魔王对抗，每一个选择都可能开启一段截然不同的人生。", "这类作品的核心吸引力，正是那种未知与探索带来的无限可能性。"] },
      { heading: "从萌新到强者的成长", paragraphs: ["大多数异世界冒险作品，都会讲述主角从一个不起眼的萌新，逐步成长为足以守护他人的强者的过程。", "这种成长轨迹，恰恰满足了观众内心对自我提升的渴望，看着主角一步步变强，仿佛自己也跟着获得了力量。"] },
      { heading: "世界观与角色同样重要", paragraphs: ["一部优秀的冒险作品，需要精彩的世界观设定与鲜活的角色群像共同支撑。宏大的地图、丰富的种族、各有特色的伙伴，共同构成了一个令人向往的冒险世界。", "希望这份指南，能帮你更好地领略异世界冒险的独特魅力。"] },
    ],
  },
  {
    id: 8,
    title: "奇幻动漫美学：那些让人叹为观止的魔法世界",
    summary: "探索奇幻动漫中瑰丽的魔法世界，从场景到魔法设定，感受想象力的极致绽放。",
    category: "奇幻",
    categorySlug: "qi-huan",
    cover: "https://readdy.ai/api/search-image?query=Majestic%20stylized%20anime%20illustration%20of%20a%20magical%20wizard%20tower%20amidst%20floating%20islands%20and%20glowing%20spell%20circles%2C%20warm%20violet%20and%20gold%20color%20palette%2C%20enchanting%20atmosphere%2C%20artistic%20digital%20painting%2C%20high%20detail%2C%20dramatic%20magic%20lighting%2C%20clean%20balanced%20background&width=1200&height=750&seq=article-08&orientation=landscape",
    author: "魔法使小铃",
    date: "2026-06-28",
    views: 8765,
    tags: ["奇幻", "魔法", "美学"],
    content: [
      { heading: "想象力的极致绽放", paragraphs: ["奇幻动漫最令人着迷的地方，是它把人类对魔法与未知的向往，具象化为一个个令人惊叹的视觉奇观。高耸入云的魔法塔、漂浮于云端的岛屿、流转着光芒的魔法阵，都让人目不暇接。", "这些瑰丽的场景，不仅是一幅幅视觉盛宴，更是创作者想象力的极致绽放。"] },
      { heading: "魔法体系的精密设定", paragraphs: ["优秀的奇幻作品，会为它的魔法世界建立一套完整而自洽的体系。元素的属性、魔法的层级、施法的规则，每一个细节都经过精心的设计。", "这种精密的世界观设定，让魔法世界显得真实可信，也让观众更容易沉浸其中。"] },
      { heading: "美学与叙事的统一", paragraphs: ["奇幻动漫的美学，绝不是孤立的视觉堆砌。它始终与故事叙事紧密相连，用瑰丽的画面为剧情服务，让美学与叙事达到和谐的统一。", "当你走进这些魔法世界，你会发现，这里不仅有美不胜收的画面，更有引人入胜的故事。"] },
    ],
  },
  {
    id: 9,
    title: "日常系动漫的魅力：平凡生活里的闪闪发光",
    summary: "没有惊天动地，只有细水长流。日常系动漫如何在平凡中捕捉生活的闪光瞬间。",
    category: "日常",
    categorySlug: "sheng-huo",
    cover: "https://readdy.ai/api/search-image?query=Warm%20stylized%20anime%20illustration%20of%20a%20group%20of%20friends%20sharing%20a%20meal%20around%20a%20wooden%20table%20in%20a%20sunny%20Japanese%20classroom%2C%20soft%20cream%20and%20warm%20coral%20color%20palette%2C%20cozy%20slice-of-life%20atmosphere%2C%20artistic%20digital%20painting%2C%20gentle%20natural%20lighting%2C%20high%20detail%2C%20clean%20background&width=1200&height=750&seq=article-09&orientation=landscape",
    author: "小悠酱",
    date: "2026-06-20",
    views: 7632,
    tags: ["日常", "校园", "治愈"],
    content: [
      { heading: "平凡之中的闪光", paragraphs: ["日常系动漫的故事往往极其简单：上学、放学、吃饭、聊天、一起度过四季。然而正是在这些再平凡不过的日常中，创作者捕捉到了生活最真实、最动人的闪光瞬间。", "没有惊天动地的冒险，只有朋友间真诚的陪伴，这种质朴的美好反而更令人珍惜。"] },
      { heading: "慢节奏的治愈", paragraphs: ["在快节奏的现代社会，日常系动漫提供了一个难得的「慢」空间。它允许我们停下脚步，细细品味那些被忽视的生活细节。", "一个悠闲的午后、一次真诚的交谈、一段愉快的音乐，都足以成为治愈心灵的良方。"] },
      { heading: "珍惜当下的美好", paragraphs: ["日常系动漫最想传达的，或许是「珍惜当下」四个字。青春短暂，而平凡日常中的每一刻都值得被认真对待。", "当你沉浸在日常系动漫的世界里，你会慢慢发现，原来最珍贵的美好，一直就在我们身边。"] },
    ],
  },
];

export const hotAnimes = [
  { id: "anime-1", title: "烈焰征途", category: "热血", categorySlug: "re-xue", score: "9.6", episodes: "24", image: "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20fiery%20young%20protagonist%20with%20blazing%20orange%20flames%20surrounding%20them%2C%20heroic%20battle%20stance%2C%20warm%20coral%20and%20deep%20red%20color%20palette%2C%20dynamic%20energy%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20clean%20dramatic%20background&width=900&height=1200&seq=anime-01&orientation=portrait", tag: "高能热血" },
  { id: "anime-2", title: "星海恋人", category: "恋爱", categorySlug: "lian-ai", score: "9.3", episodes: "12", image: "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20romantic%20couple%20gazing%20at%20each%20other%20under%20a%20starry%20night%20sky%2C%20warm%20pink%20and%20peach%20color%20palette%2C%20sweet%20romantic%20mood%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20clean%20dreamy%20background&width=900&height=1200&seq=anime-02&orientation=portrait", tag: "甜蜜暴击" },
  { id: "anime-3", title: "森林咖啡馆", category: "治愈", categorySlug: "zhi-yu", score: "9.4", episodes: "13", image: "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20cozy%20forest%20cafe%20with%20a%20friendly%20barista%20serving%20hot%20drinks%2C%20soft%20green%20and%20cream%20color%20palette%2C%20warm%20healing%20atmosphere%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20clean%20serene%20background&width=900&height=1200&seq=anime-03&orientation=portrait", tag: "治愈满分" },
  { id: "anime-4", title: "苍穹哨站", category: "科幻", categorySlug: "ke-huan", score: "9.2", episodes: "26", image: "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20space%20soldier%20in%20a%20mech%20suit%20standing%20in%20a%20futuristic%20starport%2C%20cool%20teal%20and%20deep%20blue%20color%20palette%2C%20sci-fi%20atmosphere%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20clean%20futuristic%20background&width=900&height=1200&seq=anime-04&orientation=portrait", tag: "硬核科幻" },
  { id: "anime-5", title: "爆笑俱乐部", category: "搞笑", categorySlug: "gao-xiao", score: "9.1", episodes: "24", image: "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20group%20of%20goofy%20comedy%20characters%20laughing%20hysterically%20with%20bright%20vibrant%20colors%2C%20warm%20yellow%20and%20coral%20color%20palette%2C%20fun%20playful%20mood%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20clean%20colorful%20background&width=900&height=1200&seq=anime-05&orientation=portrait", tag: "笑点密集" },
  { id: "anime-6", title: "幻境旅人", category: "冒险", categorySlug: "mao-xian", score: "9.5", episodes: "24", image: "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20of%20a%20brave%20traveler%20with%20a%20compass%20and%20backpack%20standing%20on%20a%20floating%20island%20viewpoint%2C%20warm%20golden%20and%20emerald%20color%20palette%2C%20epic%20adventure%20mood%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20clean%20panoramic%20background&width=900&height=1200&seq=anime-06&orientation=portrait", tag: "异世界冒险" },
];